"use client";

import type { HeaderActionsProps } from "./types/header-actions.types";

import { headerActionsStyles } from "./styles/header-actions.styles";

export const HeaderActions: React.FC<HeaderActionsProps> = (props) => {
  const { children, className, ...rest } = props;
  return (
    <div className={headerActionsStyles({ className })} {...rest}>
      {children}
    </div>
  );
};

HeaderActions.displayName = "HeaderActions";
